import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import DriverData from "../../components/datatables/driver/DriverData";
import { fetchDrivers } from "../../feature/drivers/driverSlice";

const Drivers = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDrivers());
    window.scrollTo({ top: "0", behavior: "smooth" });
  }, [dispatch]);

  return (
    <Box component={Paper} minHeight={"600px"} elevation={0}>
      <Box px={3} py={2}>
        <Typography variant='h4'>Drivers</Typography>
      </Box>
      <Divider />
      <Box px={3} py={2}>
        <DriverData />
      </Box>
      <Box width={"50%"} mx='auto' my={3} p={3}>
        <Pagination count={10} showFirstButton showLastButton shape='rounded' />
      </Box>
    </Box>
  );
};
export default Drivers;
